import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {ProductsDocumentsService, ProductsService} from '../../../services';
import {listProductDocument} from '../../../helpers/constant';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-add-document-to-product',
  templateUrl: './add-document-to-product.component.html',
  styleUrls: ['./add-document-to-product.component.scss']
})
export class AddDocumentToProductComponent implements OnInit {
  isVisible = false;
  name = '';
  barcode = '';
  products = [];
  totalProduct = 0;
  pageProduct = 1;
  pageSizeProduct = 10;
  loadingProduct = false;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  // tslint:disable-next-line:variable-name
  list_id = [];
  // tslint:disable-next-line:variable-name
  @Output() emitData = new EventEmitter();
  documentProduct: any = [];

  form = this.fb.group({
    docProductType: [null, [Validators.required]],
  });

  // tslint:disable-next-line:variable-name
  loading_btn = false;
  isAdmin = false;
  constructor(
    private notification: NzNotificationService,
    private productsService: ProductsService,
    private productsDocumentsService: ProductsDocumentsService,
    private  fb: FormBuilder
  ) { }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    const user = localStorage.getItem('currentUser');
    // @ts-ignore
    this.isAdmin = JSON.parse(user).isAdmin;
    if (this.isAdmin) {
      this.onFetchListDocumentTypes()
    }
  }

  onFetchListDocumentTypes() {
    this.productsDocumentsService.listDocumentType({
      page: 1,
      pageSize: 1000,
      type: 'PRODUCT',
      isDocument: true
    }).subscribe((res) => {
      this.documentProduct = res.data || []
    })
  }

  loadProduct() {
    this.isVisible = true;
    this.loadingProduct = true;
    const queryProduct = {
      product_name: this.name !== undefined ? this.name : '',
      barcode: this.barcode !== undefined ? this.barcode : '',
      page: this.pageProduct,
      page_size: this.pageSizeProduct
    };
    this.productsService.getAll(queryProduct).subscribe(
      (res) => {
        this.loadingProduct = false;
        if (res.code === 1 && res.data.items !== null) {
          const data = res.data.items;
          this.totalProduct = res.data.totalElement;
          this.products = data;
          this.refreshStatus();
          return;
        }
        this.products = [];
        this.totalProduct = 0;
      },
      (error) => {
        this.products = [];
        this.totalProduct = 0;
        this.loadingProduct = false;
      }
    );
  }
  search() {
    this.pageProduct = 1;
    this.loadProduct();
  }
  reset() {
      this.pageProduct = 1;
      this.name = undefined;
      this.barcode = undefined;
      this.loadProduct();
  }
  // checkbox multiple
  checkAll(value: boolean) {
    this.products.forEach(item => (this.mapOfCheckedId[item.productId] = value));
    this.refreshStatus();
  }
  refreshStatus() {
    // console.log(this.mapOfCheckedId);
    if (this.products.length > 0) {
      this.isAllDisplayDataChecked = this.products.every(item => this.mapOfCheckedId[item.productId]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.products.some(item => this.mapOfCheckedId[item.productId]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }
  choiceProduct() {
    // tslint:disable-next-line:forin
    if (this.isAdmin) {
      // tslint:disable-next-line:forin
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      if (!this.form.valid) {return; }
    }
    if (!this.list_id.length) {
      this.notification.error(
        'Có lỗi xảy ra',
        'Chưa chọn sản phẩm'
      );
      return;
    }
    this.loading_btn = true;
    this.emitData.emit({
      data: this.list_id,
      docProductType: this.form.get('docProductType').value
    });
  }
  showModal() {
    this.isVisible = true;
    this.mapOfCheckedId = {};
    this.list_id = [];
    this.loading_btn = false;
    this.pageProduct = 1;
    this.pageSizeProduct = 10;
    this.name = '';
    this.barcode = '';
    this.loadProduct();
    this.form.reset();
  }
  cancelLoadingBtn() {
    this.loading_btn = false;
  }
  cancelModal() {
    this.isVisible  = false;
  }
}
